import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-feedback',
  imports: [TranslateModule],
  templateUrl: './confirm-feedback.component.html',
  styleUrl: './confirm-feedback.component.css',
})
export class ConfirmFeedbackComponent {
  @Input() isHappy: boolean = true;
  @Input() rating: number = 5;
  @Output() continue = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  onContinue() {
    this.continue.emit();
  }
}
